import { PriceSummary as PriceSummaryInterface } from '@teko/cart/v2';
import {
  Caption,
  Col,
  Currency,
  Row,
  Shape,
  SubTitle,
  Tag,
  styled,
} from '@teko/ds-desktop';
import { useFeatureFlags } from 'contexts';
import { useFormatNumber } from 'hooks';
import { t } from 'i18n';
import React from 'react';

// add value and subscript fields to show on screen
interface PriceSummaryEnhancedInterface
  extends Omit<PriceSummaryInterface, 'value'> {
  value?: string | React.ReactNode;
}

interface PriceSummaryProps {
  priceSummary: PriceSummaryEnhancedInterface[];
  total: number;
}

const SummaryLine = ({
  summaryLine,
}: {
  summaryLine: PriceSummaryEnhancedInterface;
}) => {
  const { name, value, isHighlighted, tags } = summaryLine;

  const fomartTag = (tag: string) => {
    return tag.length > 12 ? tag.substring(0, 12) + '...' : tag;
  };

  return (
    <Row justify="space-between" align="top" marginBottom="s4" wrap={false}>
      <Col>
        <StyledSubTitle level={2} weight="regular">
          {name}
          {!!tags?.length && (
            <Row justify="start">
              {tags.map((tag, j) => (
                <Tag
                  key={j}
                  marginTop="s4"
                  content={fomartTag(tag)}
                  type="ghost"
                  variant="error"
                  marginRight="s4"
                />
              ))}
            </Row>
          )}
        </StyledSubTitle>
      </Col>
      <Col style={{ textAlign: 'right' }}>
        <SubTitle
          level={2}
          weight="regular"
          color={isHighlighted ? 'secondary500' : ''}
        >
          {value}
        </SubTitle>
      </Col>
    </Row>
  );
};

export const PriceSummary = ({ priceSummary, total }: PriceSummaryProps) => {
  const formatNumber = useFormatNumber();
  const { flags } = useFeatureFlags();
  priceSummary = flags?.epic_omni_1034
    ? priceSummary
    : [
        ...priceSummary,
        {
          name: t('Thành tiền'),
          value: (
            <Currency
              value={total}
              formattedValue={formatNumber(total)}
              color="primary500"
              weight="bold"
              className="att-final-price"
            />
          ),
        },
      ];
  return (
    <>
      <Shape
        paddingTop="s8"
        paddingBottom="s8"
        className="att-checkout-summary"
      >
        {priceSummary.map((item, index) => (
          <SummaryLine summaryLine={item} key={index} />
        ))}
        <Row justify="end">
          <Caption level={2} color="textSecondary">
            {`(${t('Đã bao gồm VAT')})`}
          </Caption>
        </Row>
      </Shape>
    </>
  );
};

const StyledSubTitle = styled(SubTitle)`
  display: flex;
  flex-wrap: wrap;
  column-gap: 4px;
`;
